import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $padded?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* CORE-3512: respiro lateral opt-in — só a aba Comentários do workspace
     (embedded) usa; o drawer antigo mantém o layout original */
  padding: ${({ $padded }) => ($padded ? '24px 24px 16px' : '24px 0 0')};
  gap: 40px;
`;

type SectionProps = {
  gap: number;
  height?: number;
};

export const Section = styled.div<SectionProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap}px;
  width: 100%;

  ${({ height }) =>
    height &&
    css`
      max-height: ${height}px;

      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
    `}

  form {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 8px;

    .input-list {
      flex: 1;
    }

    /* Smaller comment box. */
    .editor-container {
      min-height: 44px;
    }

    .extra-content {
      display: flex;
      justify-content: end;
      flex-shrink: 0;
    }

    .submit-button {
      flex-direction: column-reverse;
      gap: 2px;
      height: auto;
      min-height: unset;
      padding: 8px 16px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
